import { UAParser } from 'ua-parser-js'

export const UserAgentInstance = new UAParser(window.navigator.userAgent)

export function isTouch() {
    const device = UserAgentInstance.getDevice()
    return device.type === 'mobile' || device.type === 'tablet'
}

export function isIOS() {
    const os = UserAgentInstance.getOS()
    return os.name === 'iOS'
}

export function isMacOS() {
    const os = UserAgentInstance.getOS()
    return os.name === 'macOS'
}

export function isSafari() {
    const browser = UserAgentInstance.getBrowser()
    return /safari/i.test(browser.name ?? '')
}

export function isAndroid() {
    const os = UserAgentInstance.getOS()
    return os.name === 'Android'
}

export function isPWA() {
    return matchMedia !== undefined && matchMedia('(display-mode: standalone)')?.matches
}

export function getBrowserName() {
    const browser = UserAgentInstance.getBrowser()
    return browser.name
}

export function isReduceMotion() {
    return !!window?.matchMedia('(prefers-reduced-motion: reduce)')?.matches
}

const device = {
    get isTouch() {
        return isTouch()
    },
    isIOS: isIOS,
    isAndroid: isAndroid,
    isSafari: isSafari(),
    isPWA: isPWA(),
    isReduceMotion: isReduceMotion(),
}

export function useDevice() {
    return device
}
